import { BellRing, BookOpenCheck, BugOff, CalendarRange, FileText, Heart, MonitorDot, Settings, ShoppingBag, ShoppingCart, Undo2, UserRound, MessageSquare, Building, GraduationCap, Users, BookOpen, Target, Calendar, CalendarDays, DollarSign, Banknote, Clock, ClipboardList } from "lucide-react";

const menuData: any = [
  // {
  //     label: 'menu',
  //     isTitle: true,
  // },
  {
    id: "dashboard",
    label: 'Dashboard',
    link: "/dashboard",
    icon: <MonitorDot />,
    roles: [1, 2], // Admin, Teacher
  },
  {
    id: "parent-dashboard",
    label: 'Parent Dashboard',
    link: "/parent-dashboard",
    icon: <MonitorDot />,
    roles: [3], // Parent only
  },
  // {
  //   id: 'pest-control',
  //   label: 'Pest Control',
  //   link: '/pest-control',
  //   icon: <BugOff />,
  // },

  // {
  //   id: 'work-orders',
  //   label: 'Work Orders',
  //   link: '/coming-soon',
  //   icon: <BookOpenCheck />,
  // },
  // {
  //   id: 'manage-college',
  //   label: 'Manage College',
  //   link: '/manage-college',
  //   icon: <Building />,
  // },
   {
    id: 'academic-year',
    label: 'Academic Years',
    link: '/academic-years',
    icon: <CalendarRange />,
    roles: [1], // Admin only
  },
  {
    id: 'program',
    label: 'Programs',
    link: '/programs',
    icon: <Target />,
    roles: [1], // Admin only
  },

   {
    id: 'teacher',
    label: 'Teachers',
    link: '/teachers',
    icon: <GraduationCap />,
    roles: [1], // Admin only
  },
  {
    id: 'class',
    label: 'Classes',
    link: '/classes',
    icon: <BookOpen />,
    roles: [1], // Admin only
  },
  {
    id: 'student',
    label: 'Students',
    link: '/students',
    icon: <Users />,
    roles: [1, 2], // Admin and Teacher
  },
  {
    id: 'attendance',
    label: 'Monthly Attendance',
    link: '/monthly-attendance',
    icon: <Calendar />,
    roles: [1, 2], // Admin and Teacher
  },
  {
    id: 'daily-attendance',
    label: 'Daily Attendance',
    link: '/daily-attendance',
    icon: <CalendarDays />,
    roles: [1, 2], // Admin and Teacher
  },
  {
    id: 'fees',
    label: 'Student Fees',
    link: '/student-fees',
    icon: <DollarSign />,
    roles: [1], // Admin only
  },
  {
    id: 'salary',
    label: 'Teacher Salary',
    link: '/teacher-salary',
    icon: <Banknote />,
    roles: [1], // Admin only
  },
  {
    id: 'daily-hour-log',
    label: 'Daily Hour Log',
    link: '/daily-hour-log',
    icon: <Clock />,
    roles: [1, 2], // Admin and Teacher
  },
  {
    id: 'homework',
    label: 'Homework',
    link: '/homework',
    icon: <ClipboardList />,
    roles: [1, 2], // Admin and Teacher
  },
  {
    id: 'application-users',
    label: 'Application Users',
    link: '/application-users',
    icon: <UserRound />,
    roles: [1], // Admin only
  },
  // {
  //   id: 'system-settings',
  //   label: 'System Settings',
  //   link: '/system-settings',
  //   icon: <Settings />,
  // },

];



export const UserPermissions: any = [
  {
    resource: "brands"
  },
  {
    resource: "productimages"
  },
  {
    resource: "faqs"
  },
  {
    resource: "users"
  },
  {
    resource: "seasons"
  },
  {
    resource: "categories"
  },
  {
    resource: "businessaddresses"
  },
  {
    resource: "wishlists"
  },
  {
    resource: "orderheaders"
  },
  {
    resource: "ordertrackings"
  },
  {
    resource: "shippingaddresses"
  },
  {
    resource: "billingaddresses"
  },
  {
    resource: "coupons"
  },
  {
    resource: "orders"
  },
  {
    resource: "businesses"
  },
  {
    resource: "banners"
  },
  {
    resource: "attributevalues"
  },
  {
    resource: "attributes"
  },
  {
    resource: "products"
  },
  {
    resource: "cms"
  },
  {
    resource: "productcolors"
  },
  {
    resource: "carts"
  },
  {
    resource: "productpackagings"
  },
  {
    resource: "orderlines"
  },
  {
    resource: "productsizes"
  },
  {
    resource: "productvariants"
  },
  {
    resource: "announcements"
  },
  {
    resource: "complaints"
  },
  {
    resource: "complaintstatus"
  },
  {
    resource: "complaintpriorities"
  },
  {
    resource: "complaintcategories"
  },
  {
    resource: "complaintlocations"
  },
  {
    resource: "complaintcomments"
  },
  {
    resource: "businesscoupons"
  }
]

export { menuData };